import { DelayedDbType } from '../../../store/offline-db/delayed-db/delayed-db.type';
import { router } from '../../../modules/shared/shared.global-service';
import { getServiceId } from '../../medical-service/work/work-detail/utils/work.servise-util';
import { WorkTypeEnum } from '@libs/types/src/common/enum/work-type.enum';
import { userServices } from '../../../store/services';

async function createWork(item: DelayedDbType): Promise<void> {
    const state = item.input as any;
    const ids = await getServiceId(state.folderId);
    if (state?.workType === WorkTypeEnum.DOCTOR_RECORD) {
        const svc = userServices().find((it) => it.id == ids.serviceId);
        state.expertise = svc?.expertise?.code;
    }
    state.delayedId = item.id;

    await router.navigateByUrl(item.url, { state: { ...state, ...ids, ...JSON.parse(state?.workData || {}), workData: undefined } });
}

export async function continueDelayedWork(item: DelayedDbType): Promise<void> {
    const key = `${item.resource}.${item.method}`;
    switch (key) {
        case 'work.create':
            return createWork(item);
        default:
            await router.navigateByUrl(item.url, { state: item.input });
    }
}
